import { openBlock, createElementBlock, renderSlot } from 'vue';

const _hoisted_1 = { class: "el-button-group" };
function render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1, [
    renderSlot(_ctx.$slots, "default")
  ]);
}

export { render };
//# sourceMappingURL=button-group.vue_vue_type_template_id_1bab7d77_lang.mjs.map
